import { useState } from 'react'

import QuestionMark from '~/components/icons/IconQuestion'
import IconPlus from '~/components/icons/IconPlus'

export default function Accordion({ title, body }) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => setIsOpen((x) => !x)

  return (
    <div className="text-grey-700">
      <div
        className="flex flex-row items-start cursor-pointer"
        onClick={handleClick}
      >
        <div className={`${isOpen ? 'text-pink-800' : ''} pt-1`}>
          <QuestionMark />
        </div>
        <div className="flex-grow mx-2 md:mx-6">
          <span className="font-sans md:text-lg">{title}</span>
          <p
            className={`font-serif text-sm md:text-base mt-3 md:mt-8 leading-6 ${
              isOpen ? 'block' : 'hidden'
            }`}
          >
            {body}
          </p>
        </div>
        <div className="mt-1 md:mt-2">
          <IconPlus isOpen={isOpen} />
        </div>
      </div>
    </div>
  )
}
